import { z } from 'zod';

export const FacilityDtoSchema = z.object({
  /** Unique identifier of the facility */
  id: z.string(),
  /** Human-readable facility name */
  name: z.string(),
  /** Facility street address */
  address: z.string(),
  /** Start of standard operating hours (time portion only) */
  startTime: z.string(),
  /** End of standard operating hours (time portion only) */
  endTime: z.string(),
  /** IANA time zone identifier the facility operates in */
  timeZone: z.string(),
  /** Optional contact information for the facility */
  contactInfo: z.string().nullable().optional(),
});

export type FacilityDto = z.infer<typeof FacilityDtoSchema>;

export const PaginatedFacilitiesResponseDtoSchema = z.object({
  data: z.array(FacilityDtoSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});
export type PaginatedFacilitiesResponseDto = z.infer<typeof PaginatedFacilitiesResponseDtoSchema>;

export interface FacilitiesFilterParams {
  search?: string;
  page?: number;
  limit?: number;
}

export interface CreateFacilityDto {
  name: string;
  address: string;
  startTime: string;
  endTime: string;
  timeZone: string;
  contactInfo?: string;
}

export interface UpdateFacilityDto {
  name?: string;
  address?: string;
  startTime?: string;
  endTime?: string;
  timeZone?: string;
  contactInfo?: string | null;
}
